import React from 'react'

import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

import ProfileFormProvider from 'utils/providers/ProfileFormProvider'

import ProfileFormProgress from './ProfileFormProgress'
import AuthNavbar from 'components/mobile/AuthNavbar'
import ProfileFormSteps from './ProfileFormSteps'
import { StickyButtons } from './helpers'

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.palette.common.white,
  },
  wrapper: {
    margin: 0,
    padding: 0,
  },
  content: {
    maxWidth: '100%',
    padding: '0 16px',
    marginTop: 40,
    minHeight: `calc(100vh - ${theme.custom.mobileAuthNavbarHeight}px - ${theme.custom.mobileAuthSupportHeight}px - 44px)`,
  },
  navbar: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
  },
  support: {
    height: theme.custom.mobileAuthSupportHeight,
  },
}))

const MobileProfileForm = () => {
  const classes = useStyles()

  return (
    <ProfileFormProvider>
      <Grid
        container
        flexDirection="column"
        justifyContent="space-between"
        alignItems="stretch"
        className={classes.root}
      >
        <Grid
          container
          flexDirection="column"
          alignItems="stretch"
          flexGrow={1}
          mb={1}
        >
          <Grid className={classes.navbar}>
            <AuthNavbar />
          </Grid>
          <Grid className={classes.content}>
            <Grid mb={3}>
              <ProfileFormProgress />
            </Grid>
            <ProfileFormSteps />
          </Grid>
        </Grid>
        <StickyButtons />
      </Grid>
    </ProfileFormProvider>
  )
}

export default MobileProfileForm
